var map = {
	"./China.svg": "db77",
	"./English.svg": "b33c",
	"./anli.svg": "c5bc",
	"./circle.svg": "091a",
	"./components.svg": "e3b6",
	"./dashboard.svg": "f782",
	"./ellipse.svg": "89a7",
	"./example.svg": "30c3",
	"./exit-fullscreen.svg": "dbc7",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./flow.svg": "3b78",
	"./form.svg": "eb1b",
	"./fullscreen.svg": "9921",
	"./international.svg": "17df",
	"./link.svg": "18f0",
	"./map.svg": "a13f",
	"./nested.svg": "dcf8",
	"./password.svg": "2a3d",
	"./polygon.svg": "58eb",
	"./questionnaire.svg": "919d",
	"./rect.svg": "701f",
	"./system.svg": "30a9",
	"./table.svg": "47f1",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5",
	"./workplace.svg": "d9bd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";